export default "__VITE_ASSET__Drv6iUv7__"